import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import Results from './Results';
import { PageHeader, Section } from '../../shared/components';

interface Props {
  query: string;
}

const ResultsHome: React.FC<Props> = ({ query }) => {
  const { t } = useTranslation();

  return (
    <Container className="search">
      <PageHeader title={t('searchResults')} noBack />
      <Row>
        <Section>
          <Results query={query} />
        </Section>
      </Row>
    </Container>
  );
};

export default ResultsHome;
